<template>
  <div class="c-idea g-container">
    <Breadcrumb class="m-bread">
      <BreadcrumbItem> <Icon type="ios-home-outline"></Icon> 选择投放账号 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="logo-buffer"></Icon> 设置计划组 </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="ios-cafe"></Icon> 设置创意 </BreadcrumbItem>
    </Breadcrumb>

    <!-- 滚动区域 -->
    <div class="module-content" ref="container">
      <moduler v-for="item in subModules" :key="item.id" :title="item.name" :name="item.href">
        <!-- 创意组 -->
        <template v-if="item.href === 'idea_tool'">
          <affix target="c-create-scroll" :offsetTop="65">
            <div class="c-idea-bar">
              <div ref="barContent" class="c-bar-content">
                <template v-for="(creative, i) in creativeData">
                  <div :key="i" @click.stop="setIdea(i)" :class="classes(creative)">
                    <span>创意组{{ i + 1 }}</span>
                    <span class="m-remove" @click.stop="delIdea(i)">x</span>
                  </div>
                </template>
              </div>
              <div class="c-add-btn">
                <Button icon="ios-add" :disabled="ideaLen" @click.stop="appendIdea">添加创意组</Button>
                <Button type="info" disabled @click.stop="campaignModal = true">选择创意组</Button>
                <!-- :disabled="!accountData.length" -->
              </div>
            </div>
          </affix>
        </template>

        <!-- 基础信息 -->
        <template v-if="item.href === 'idea_base' && show">
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意组名称</span>
            </Col>
            <Col span="12">
              <input-len v-model="formItem.ideaName" placeholder="最大20个字符，1个中文等于2个字符" width="480" :max="20" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意名称</span>
            </Col>
            <Col span="12">
              <input-len v-model="formItem.creativeFeedName" placeholder="最大100个字符，1个中文等于2个字符" width="480" :max="100" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">计划位置</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.scene" type="button" @on-change="changScene">
                <Radio :label="1" :disabled="formItem.union">优选流量</Radio>
                <Radio :label="2" :disabled="formItem.union">按场景选择计划位</Radio>
                <Radio :label="4" :disabled="!formItem.union">百青藤</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.scene === 2">
            <Col span="4" class="col-item">
              <span class="item-field">&nbsp;</span>
            </Col>
            <Col span="12">
              <CheckboxGroup v-model="formItem.ftypes" @on-change="changeFtypes">
                <Checkbox :label="1">百度信息流</Checkbox>
                <Checkbox :label="2">贴吧信息流</Checkbox>
                <Checkbox :label="8">好看视频</Checkbox>
                <Checkbox :label="64">百度小说</Checkbox>
              </CheckboxGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">投放版位</span>
            </Col>
            <Col span="12">
              <Mixcheck v-model="formItem.producttypes">
                <Radio-item :label="0">默认</Radio-item>
                <Check-item :label="1" :disabled="disabledptype">列表页</Check-item>
                <!-- <Check-item :label="2" :disabled="disabledptype">详情页（白名单功能）</Check-item> -->
              </Mixcheck>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">创意形式</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.ideaType" type="button">
                <Radio :label="1">程序化</Radio>
              </RadioGroup>
            </Col>
          </Row>
        </template>

        <template v-if="item.href === 'idea_media' && show">
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">创意素材</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="formItem.image_mode" type="button">
                <Radio label="CREATIVE_IMAGE_MODE_VIDEO"
                  >视频 {{ formItem.videoCreative && formItem.videoCreative.length ? `(${formItem.videoCreative.length})` : '' }}</Radio
                >
                <Radio label="CREATIVE_IMAGE_MODE_LARGE"
                  >大图 {{ formItem.largeCreative && formItem.largeCreative.length ? `(${formItem.largeCreative.length})` : '' }}</Radio
                >
                <Radio label="CREATIVE_IMAGE_MODE_SMALL"
                  >小图 {{ formItem.imageCreative && formItem.imageCreative.length ? `(${formItem.imageCreative.length})` : '' }}</Radio
                >
                <Radio label="CREATIVE_IMAGE_MODE_GROUP"
                  >组图 {{ formItem.groupCreative && formItem.groupCreative.length ? `(${formItem.groupCreative.length})` : '' }}</Radio
                >
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_VIDEO'" class="row-item" :gutter="12">
            <Col span="4" class="row-item-label m-creat-box">
              <Button v-if="formItem.videoCreative.length < 6" type="default" icon="md-add" @click="addCreative('video')"></Button>
            </Col>
            <Col span="18">
              <creative
                type="video"
                :data="formItem.videoCreative"
                :source="formItem.creativeDetails"
                :local="false"
                :verify="verify"
                @on-select="selectImage"
                @on-delete="deleteItem"
              />
            </Col>
          </Row>
          <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_LARGE'" class="row-item" :gutter="12">
            <Col span="4" class="row-item-label m-creat-box">
              <Button v-if="formItem.largeCreative.length < 6" type="default" icon="md-add" @click="addCreative('large')"></Button>
            </Col>
            <Col span="18">
              <creative
                type="large"
                :data="formItem.largeCreative"
                :source="formItem.creativeDetails"
                :local="false"
                :verify="verify"
                @on-select="selectImage"
                @on-delete="deleteItem"
              />
            </Col>
          </Row>
          <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_SMALL'" class="row-item" :gutter="12">
            <Col span="4" class="row-item-label m-creat-box">
              <Button v-if="formItem.imageCreative.length < 6" type="default" icon="md-add" @click="addCreative('image')"></Button>
            </Col>
            <Col span="18">
              <creative
                type="image"
                :data="formItem.imageCreative"
                :source="formItem.creativeDetails"
                :local="false"
                :verify="verify"
                @on-select="selectImage"
                @on-delete="deleteItem"
              />
            </Col>
          </Row>
          <Row v-if="formItem.image_mode === 'CREATIVE_IMAGE_MODE_GROUP'" class="row-item" :gutter="12">
            <Col span="4" class="row-item-label m-creat-box">
              <Button v-if="formItem.groupCreative.length < 6" type="default" icon="md-add" @click="addCreative('group')"></Button>
            </Col>
            <Col span="18">
              <creative
                type="group"
                :data="formItem.groupCreative"
                :source="formItem.creativeDetails"
                :local="false"
                :verify="verify"
                @on-select="selectImage"
                @on-delete="deleteItem"
              />
            </Col>
          </Row>
          <Row style="margin-top: -30px">
            <Col span="4" class="row-item-label"> </Col>
            <Col span="18">
              <span style="color: red">{{ errMsg }}</span>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">标题</span>
            </Col>
            <Col span="10">
              <select-title
                v-model="formItem.titleList"
                :words="wordData"
                :max="6"
                :open-id="opId"
                @on-append="addTitleList"
                @on-delete="delTitleList"
              />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="formItem.materialstyle === 113">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">副标题</span>
            </Col>
            <Col span="12">
              <input-len v-model="formItem.subtitle" placeholder="最大24个字符，1个中文等于2个字符" width="480" :max="24" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-else>
            <Col span="4" class="col-item">
              <span class="item-field">落地页URL</span>
            </Col>
            <Col span="12">
              <Input readonly placeholder="内部计划自动生成" style="width: 480px" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">品牌名称</span>
            </Col>
            <Col span="12">
              <input-len v-model="formItem.brand" charset="init" placeholder="最大11个字符" width="480" :max="11" />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field row-item-must">品牌头像</span>
            </Col>
            <Col span="12">
              <cardptom-icon
                :value="formItem.userPortrait"
                :width="120"
                :file-size="1024"
                :local="false"
                :sources="formItem.creativeDetails"
                @on-select="addCreative('logo')"
              />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-show="false">
            <Col span="4" class="col-item">
              <span class="item-field">播放量</span>
            </Col>
            <Col span="12" class="col-flex">
              <i-Switch v-model="formItem.playnum" :true-value="1" :false-value="0" />
            </Col>
          </Row>

          <template v-if="isLink && isMiniProgram">
            <Row class="row-item" :gutter="12">
              <Col span="4" class="col-item">
                <span class="item-field">小程序名称</span>
              </Col>
              <Col span="12">
                <Input readonly :value="miniProgramInfo.mediaGameName" placeholder="无需填写，自动获取" />
                <p style="color: red" v-if="!miniProgramInfo.mediaGameName">
                  未获取到小程序信息，请前往【天工开物】-【AI工具】 -【游戏应用管理】创建小程序相关信息
                </p>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="4" class="col-item">
                <span class="item-field">小程序原始ID</span>
              </Col>
              <Col span="12" class="col-flex">
                <Input readonly :value="miniProgramInfo.originId" placeholder="无需填写，自动获取" />
              </Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="4" class="col-item">
                <span class="item-field">版本URL</span>
              </Col>
              <Col span="12" class="col-flex">
                <Button type="primary">正式版</Button>
              </Col>
            </Row>
          </template>

          <Row class="row-item" :gutter="12">
            <Col span="4" class="col-item">
              <span class="item-field">点击监测链接</span>
            </Col>
            <Col span="12">
              <Input readonly placeholder="内部计划自动生成" />
            </Col>
          </Row>
        </template>
      </moduler>

      <AssetsSelectorModal
        :visible.sync="showSelectorModal"
        v-bind="{ ...selectorProps, selectedGameId: gameId }"
        @close="onSelectorClose"
        @confirm="uploadFileHandle"
      >
        <template v-slot:assetType="{ getData }">
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.VIDEO]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]"
          >
            视频
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.IMAGE]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
          >
            图片
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled.cover"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]"
          >
            封面
          </el-radio>

          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.LOGO]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO]"
          >
            LOGO
          </el-radio>
        </template>

        <template v-slot:sizes="{ getData }">
          <el-select
            style="width: 200px"
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            v-model="selectorProps.form.size"
            @change="getData"
          >
            <!-- 根据当前选择素材的类型来获取尺寸下拉数据 -->
            <el-option
              v-for="item in MATERIAL_TYPE_SIZES[selectorProps.assetType]"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </template>
      </AssetsSelectorModal>

      <!-- 选择素材 -->
      <!-- <uploader
        v-model="uploadModel"
        :type="uploadType"
        :width="uploadWidth"
        :height="uploadHeight"
        :size="uploadSize"
        :smart="uploadSmart"
        :media="media"
        :multiple="uploadMult"
        :betch="uploadBatch"
        :default-game-id="gameId"
        :game-data="gameData"
        :game-group-data="gameGroupData"
        :operator-data="operatorData"
        :label-data="labelData"
        @change="switchType"
        @upload="uploadFileHandle"
      /> -->
    </div>

    <affix target="c-create-scroll" :offsetBottom="0">
      <div class="c-idea-submit">
        <Row :gutter="12">
          <Col span="12">
            <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
          </Col>
          <Col span="12" class="c-btns-submit">
            <Button type="default" @click.stop="back">上一步</Button>
            <Button type="primary" @click.stop="submit">下一步</Button>
          </Col>
        </Row>
      </div>
    </affix>
  </div>
</template>
<script>
import mixin from './mixin'
import ideaMixin from './idea_mixin'
import { MEDIAS } from '@/common/js/constants.js'
import { isArray, timeout, deepCopy, pullKeys } from '@/common/js/utils'
import { getSession, setSession } from '@/common/js/api'
import mixinUpload from './components/idea/creative/mixin-upload'

import creativeTemplate from '@/data/baidu/creative.json'
import SelectTitle from './components/idea/media/select-title.vue'
import Creative from './components/idea/creative/creative'
import CardptomIcon from '@/components/cardptom/'

import { checkGameInfo } from '@/api/uc.local.model'
import { adAccount, adGames, getSysTag, getCaoHuaOpenIds } from '@/api/common.model'
import { getPtomGroupGames } from '@/api/material.model'

import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import AssetsSelectorModal, { makeSelectorForm } from '@/components/material-selector/index.js'

const defaultIdeaParams = {
  ideaName: '',
  creativeFeedName: '',

  creativeDetails: [],
  videoCreative: [],
  largeCreative: [],
  imageCreative: [],
  groupCreative: [],
  titleList: [],
  subtitle: '',
  brand: '',
  userPortrait: 0,
  producttypes: 0,
  ideaType: 1,
  playnum: 0
}

export default {
  name: 'bdLocalIdea',
  mixins: [mixin, ideaMixin, mixinUpload],
  components: { Creative, SelectTitle, CardptomIcon, AssetsSelectorModal },
  data() {
    return {
      MATERIAL_TYPE_ID,
      MATERIAL_TYPE,
      MATERIAL_TYPE_SIZES: {
        [MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]]: [
          { label: '1280*720' },
          { label: '720*1280' },
          { label: '1920*1080' },
          { label: '1080*1920' }
        ],
        [MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]]: [
          { label: '1140*640' },
          { label: '370*245' },
          { label: '1920*1080' },
          { label: '1080*1920' }
        ],
        [MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]]: []
      },
      showSelectorModal: false,
      selectorProps: {
        max: 1,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO],
        form: this.getInitSelectorForm()
      },
      show: null,
      verify: false,
      campaignModal: null,
      style: 0,
      gameId: '',
      landing_type: '',
      platform: 2,

      creativeElements: creativeTemplate,
      wordData: [],
      creativeData: [],
      accountData: [], // 选择创意的账号
      operatorData: [],
      gameData: [],
      gameGroupData: [],
      labelData: [],
      errMsg: '',
      miniProgramInfo: {} // 小程序回显信息
    }
  },
  computed: {
    seletedMaterialRadioDiasbled() {
      // 是否素材替换
      const isReplaceMode = this.uploadIndex > -1

      const states = {
        [MATERIAL_TYPE.IMAGE]: true,
        [MATERIAL_TYPE.VIDEO]: true,
        [MATERIAL_TYPE.LOGO]: true,
        cover: true
      }
      // 只能选择对应的素材类型
      states[this.uploadType] = false

      // 替换时，只能选择对应的素材类型
      if (isReplaceMode) {
        // 如果替换类型为封面，可以将图片radio放开，让用户可以选择图片作为封面
        if (this.uploadType === 'cover') {
          states[MATERIAL_TYPE.IMAGE] = false
        }
      }

      return states
    },
    editState() {
      return this.$route.query.t === 'edit'
    },
    classes() {
      return (item) => {
        return ['m-creative-btn', { 'm-current': item.check }]
      }
    },
    ideaLen() {
      return this.creativeData.length > 49
    },
    titleLen() {
      return 0
    },
    formItem() {
      const items = this.creativeData.filter((ret) => ret.check)
      return items.pop() || {}
    },
    disabledptype() {
      return this.formItem.scene > 1 && this.formItem.ftypes.some((ret) => ret > 2)
    },
    isAndroid() {
      return this.platform === 1
    },
    isLink() {
      return this.landing_type === 'LINK'
    },
    isMiniProgram() {
      return this.platform === 3
    }
  },
  methods: {
    getData() {
      const data = getSession('idea_params') || {}
      if (this.editState && data && Object.keys(data).length > 0) {
        Object.keys(data).forEach((ret) => {
          this.$set(this, ret, data[ret])
        })
      }
      this.$nextTick(() => {
        this.setIdea(0)
        this.show = true
      })
    },
    appendIdea() {
      const len = this.creativeData.length
      const fmt_formItem = deepCopy(this.formItem)
      let ideaParam = Object.assign({}, defaultIdeaParams, fmt_formItem) // 复制

      ideaParam = Object.assign({}, { image_mode: 'CREATIVE_IMAGE_MODE_VIDEO' }, ideaParam)
      ideaParam = Object.assign({}, ideaParam, {
        ideaName: `创意组${len + 1}`,
        creativeFeedName: this.formItem.creativeFeedName || this.planName,
        materialstyle: this.style,
        scene: this.formItem.scene || this.scene,
        union: this.scene === 4,
        ftypes: this.formItem.ftypes || this.ftypes
      })
      this.creativeData.push(deepCopy(ideaParam))
      this.setIdea(this.creativeData.length - 1)
      timeout(60).then(() => {
        this.$refs.barContent[0] && (this.$refs.barContent[0].scrollLeft = 3000)
      })
    },
    setIdea(index) {
      const item = this.creativeData[index]
      this.creativeData.forEach((ret) => {
        this.$set(ret, 'check', false)
      })
      this.$set(item, 'check', true)
    },
    delIdea(index) {
      const idx = this.creativeData.findIndex((ret) => ret.check)
      const len = this.creativeData.length
      if (len < 2) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: '不能删除最后一个创意组'
        })
        return
      }
      // 删除自己
      if (index === idx) {
        if (index > 0) this.setIdea(index - 1)
        else this.setIdea(1)
      }
      this.creativeData.splice(index, 1)
    },
    mergeCreative(ret) {
      const singlePic = this.build('image', ret.imageCreative)
      const largePic = this.build('large', ret.largeCreative)
      const package3Pic = this.build('group', ret.groupCreative)
      const horizontalVideos = this.build(
        'video',
        ret.videoCreative.filter((met) => met.id === 1)
      )
      const verticalVideos = this.build(
        'video',
        ret.videoCreative.filter((met) => met.id === 6)
      )
      return {
        singlePic,
        largePic,
        horizontalVideos,
        verticalVideos,
        package3Pic,
        titles: ret.titleList.map((met) => met.title)
      }
    },
    build(type, ret) {
      if (['image', 'large'].includes(type)) {
        return ret.map((met) => isArray(met.template) && met.template[0].image)
      } else if (type === 'group') {
        return ret.map((met) => {
          return isArray(met.template) && met.template[0].children.map((t) => t[t.name]).join(' ')
        })
      } else if (type === 'video') {
        return ret.map((met) => isArray(met.template) && met.template.map((t) => t[t.name]).join(' '))
      }
    },
    valid(ret) {
      const rules = [
        {
          name: 'ideaName',
          require: true,
          min: 1,
          max: 20,
          desc: '创意组名称'
        },
        {
          name: 'creative_name',
          require: true,
          min: 1,
          max: 100,
          desc: '创意名称'
        },
        {
          name: 'ftypes',
          relyon: 'scene',
          relyvalue: 2,
          require: true,
          min: 1,
          desc: '场景计划位'
        },
        {
          name: 'titleList',
          min: 1,
          max: 6,
          require: true,
          desc: '标题'
        },
        {
          name: 'userPortrait',
          require: true,
          min: 1,
          max: 1024,
          desc: '品牌头像'
        },
        {
          name: 'brand',
          require: true,
          min: 1,
          max: 11,
          charset: 'init',
          desc: '品牌名称'
        },
        {
          name: 'subtitle',
          relyon: 'materialstyle',
          relyvalue: 113,
          require: true,
          min: 0,
          max: 24,
          desc: '副标题'
        }
      ]
      return this.invalidPlus(ret, rules)
    },
    submit() {
      this.verify = false
      this.formErr = false
      this.errRes = []

      timeout(100).then(() => {
        // 发起验证
        const customValids = this.creativeData.map((ret) => {
          const err = [...this.valid(ret), ...this.validLen(ret)]
          const element = [...this.invalidExtand(ret)]
          return { err, element }
        })

        const errState = customValids.some((met, idx) => {
          this.index = idx
          this.errRes = met.err
          if (met.err.length > 0) return true
          else {
            const el = met.element.some((e) => {
              this.idx = e.mode
              this.errMsg = e.errMsg
              return e.stat.some((v) => !v)
            })
            if (el) {
              this.errRes.push({ feild: '创意素材', msg: '验证不通过，请逐个检查' })
            }
            return el
          }
        })

        if (this.isLink && this.isMiniProgram) {
          const { mediaGameName, originId } = this.miniProgramInfo

          if (!originId || !mediaGameName) {
            this.errRes.push({ feild: '创意素材', msg: '小程序信息获取失败' })
          }
        }

        if (this.errRes.length || errState) {
          typeof this.index === 'number' && this.setIdea(this.index) // 切到创意组
          timeout(200).then(() => {
            if (typeof this.idx === 'string') {
              // 竖版视频定成横版
              const imageMode = this.idx === 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL' ? 'CREATIVE_IMAGE_MODE_VIDEO' : this.idx
              this.$set(this.formItem, 'image_mode', imageMode)
            }
            timeout(0).then(() => {
              this.verify = true
            })
            this.formErr = true
          })
          // eslint-disable-next-line
          return false // 如果错误中断
        }
        this.jump()
      })
    },
    jump() {
      const creative_params = deepCopy(this.creativeData).map((ret) => {
        const pullArray = []
        Object.assign(ret, {
          elements: this.mergeCreative(ret),
          creative_details: ret.creativeDetails
        })
        pullArray.push(
          ...[
            'ideaName',
            'creativeFeedName',
            'union',
            'scene',
            'ftypes',
            'materialstyle',
            'producttypes',
            'ideaType',
            'elements',
            'creative_details',
            'subtitle',
            'brand',
            'userPortrait',
            'playnum'
          ]
        )

        const res = pullKeys(pullArray, ret)

        // tg4.29.0 网站推广目的，小程序平台添加信息流小程序支持
        if (this.isLink && this.isMiniProgram) {
          // ideaPluginGroup 文档 https://dev2.baidu.com/content?sceneType=0&pageId=100113&nodeId=378&subhead=
          res.ideaPluginGroup = [
            {
              wechatMiniprogramName: this.miniProgramInfo.mediaGameName, // 小程序名称
              wechatMiniprogramId: this.miniProgramInfo.originId, // 小程序原始ID
              wechatVersionType: 0, // 版本类型:0 正式版, 1 开发版, 2 体验版
              pluginType: 16596
            }
          ]
        }

        return res
      })

      console.log('creative_paramscreative_params output: ', creative_params)

      setSession('creative_params', creative_params)
      setSession('idea_params', this.$data)
      this.$router.push({ name: 'baidulocalbatch' })
    },
    back() {
      if (this.show || this.creativeData.length) {
        const goBack = () => {
          this.$router.push({
            name: 'baidulocalplan',
            query: { t: 'edit' }
          })
        }
        this.$Modal.confirm({
          title: '提示',
          content: '<p>当前编辑数据未保存，返回将丢失编辑数据。</p><p>是否保存当前数据</p>',
          loading: true,
          okText: '是',
          cancelText: '否',
          onCancel: goBack,
          onOk: () => {
            setSession('idea_params', this.$data)
            timeout(800).then(() => {
              this.$Modal.remove()
              goBack()
            })
          }
        })
      } else this.$Message.error('页面数据加载中，请等待...')
    },
    getInitSelectorForm() {
      return { ...makeSelectorForm(), size: '1280*720', media_id: MEDIAS.BAIDU }
    },
    preloadData() {
      const param = { mediaId: this.media, authFlag: 1 }

      if (this.isLink && this.isMiniProgram) {
        checkGameInfo({ gameId: this.gameId }).then((data) => {
          this.miniProgramInfo = data?.gameAppInfo || {}
        })
      }

      const reqList = [adAccount(param), getCaoHuaOpenIds(), adGames({ type: 1 }), getPtomGroupGames(), getSysTag()]
      Promise.all(reqList).then((data) => {
        const [accounts, operatorData, gameData, gameGroupData, labels] = data
        if (isArray(accounts)) {
          this.accountData = accounts.map((ret) => {
            return { id: ret.id, name: ret.name, children: [], xhr: false, disabled: false }
          })
        }
        if (isArray(operatorData)) this.operatorData = operatorData
        if (isArray(gameData)) this.gameData = gameData
        if (isArray(gameGroupData)) {
          this.gameGroupData = gameGroupData.map((ret) => {
            return {
              id: ret.groupId,
              name: ret.groupName,
              children: ret.gameIds
            }
          })
        }
        if (isArray(labels)) {
          this.labelData = labels.map((ret) => {
            return {
              id: ret.labelId,
              name: ret.content
            }
          })
        }
        if (this.editState) this.getData()
        else {
          this.appendIdea() // 增加一个创意
          this.setIdea(0)
          this.show = true
        }
      })
    }
  },
  created() {
    const { game_id, ch_platform_id, plan_name, landing_type } = getSession('inner_plan_params') || {}
    const { union } = getSession('outer_plan_params') || {}
    game_id && (this.gameId = parseInt(game_id))
    plan_name && (this.planName = plan_name)
    ch_platform_id && (this.platform = parseInt(ch_platform_id))
    landing_type && (this.style = landing_type === 'LINK' ? 114 : 113)
    this.landing_type = landing_type
    if (union === 'CUSTOM') {
      this.scene = 4
      this.ftypes = [4] // 百青藤
    } else {
      this.scene = 1
      this.ftypes = [] // 优选流量
    }
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.c-idea {
  position: relative;
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 96px);
  }

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  .c-idea-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      button {
        margin-left: 8px !important;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  // 多个素材
  .m-creative-btn {
    border-radius: 4px;
    border: solid 1px #efefef;
    position: relative;
    display: inline-block;
    line-height: 32px;
    padding: 0 12px;
    margin-right: 12px;
  }

  .m-creat-btn {
    color: #2b85e4;
  }

  .m-remove {
    position: absolute;
    cursor: pointer;
    color: #fff;
    width: 11px;
    height: 11px;
    line-height: 11px;
    font-size: 60%;
    border-radius: 9px;
    background-color: #ff635c;
    text-align: center;
    display: block;
    z-index: 11;
    top: -6px;
    right: -3px;
    transition: display 0.2s ease-in-out;
  }
}

.c-idea-bar {
  position: relative;
  flex: auto;
  display: flex;
  justify-content: space-between;
  padding: 15px 12px 15px 48px;
  background-color: #ffffff;
  white-space: nowrap;

  .c-bar-content {
    overflow-x: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: inherit;
    display: inline-block;
    flex: auto;
    padding: 5px 0;

    .m-creative-btn {
      border-radius: 4px;
      border: solid 1px #efefef;
      position: relative;
      display: inline-block;
      line-height: 32px;
      padding: 0 12px;
      margin-right: 12px;

      .m-creat-btn {
        color: #2b85e4;
      }

      .m-remove {
        position: absolute;
        cursor: pointer;
        color: #fff;
        width: 11px;
        height: 11px;
        line-height: 11px;
        font-size: 60%;
        border-radius: 9px;
        background-color: #ff635c;
        text-align: center;
        display: block;
        z-index: 11;
        top: -6px;
        right: -3px;
        transition: display 0.2s ease-in-out;
      }
    }

    .m-current {
      color: #ffffff;
      border-color: $primary-color;
      background-color: $primary-color;
    }
  }

  .c-add-btn {
    padding-top: 6px;
    text-align: right;

    button {
      margin-left: 10px !important;

      &:first-child {
        margin-left: 0 !important;
      }
    }
  }
}

.row-item {
  align-items: flex-start;

  span.item-field {
    height: 32px;
    line-height: 32px;
  }
}

.ivu-affix .c-idea-bar {
  border-bottom: 1px solid #e8eaec;
}

.row-item-label {
  text-align: right;
  padding: 8px;
}

.m-creat-box {
  min-height: 165px;
}
</style>
